import { getUserColor, SYSTEM_COLOR, avatarInitials } from '../../../utils/userColors';
import { ACTIVITY_TYPE_META, type ActivityType } from './auditConstants';

const SIZES = {
  table: { box: 30, font: 12 },
  timeline: { box: 32, font: 12 },
  panel: { box: 42, font: 16 },
} as const;

export default function UserAvatar({
  userId, name, size, isSystem = false, typeBadge,
}: {
  userId: number | null;
  name: string | null;
  size: keyof typeof SIZES;
  // true = this row has no matching account (e.g. system-initiated auto-block events, or a
  // failed login attempt with no matching user) — renders the "?" gray avatar.
  isSystem?: boolean;
  // Timeline only — the small colored circle badge in the bottom-right corner (§5 of the spec).
  typeBadge?: ActivityType;
}) {
  const { box, font } = SIZES[size];
  const unknown = userId === null && !isSystem;
  const background = isSystem ? SYSTEM_COLOR : (userId !== null ? getUserColor(userId) : '#374151');
  const content = isSystem ? '⚙' : (unknown ? '?' : avatarInitials(name || '?'));

  const badgeMeta = typeBadge ? ACTIVITY_TYPE_META[typeBadge] : null;
  const BadgeIcon = badgeMeta?.Icon;

  return (
    <div style={{ position: 'relative', width: box, height: box, flexShrink: 0 }}>
      <div
        style={{
          width: box, height: box, borderRadius: '50%', background,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontWeight: 600, fontSize: font, userSelect: 'none',
        }}
      >
        {content}
      </div>
      {badgeMeta && BadgeIcon && (
        <div
          style={{
            position: 'absolute', right: -4, bottom: -4, width: 18, height: 18, borderRadius: '50%',
            background: badgeMeta.color, border: '2px solid #161b27',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <BadgeIcon size={9} color="#fff" strokeWidth={3} />
        </div>
      )}
    </div>
  );
}
